import gql from 'graphql-tag';

export default gql`
    query geocodeLocation($input: String!) {
        viewer {
            id,
            geocodeLocation(input: $input) {
                street,
                city,
                state,
                postalCode,
                country
            }
        }
    }
`;
